import type { ContactRow } from './types';

export const CONTACT: ContactRow[] = [
  {
    title: 'Customer Services',
    tel: '020 3841 2818',
    email: 'cs@ideal4finance.co.uk',
  },
  {
    title: 'Accounts',
    tel: '020 3841 2819',
    email: 'accounts@ideal4finance.co.uk',
  },
  {
    title: 'Loans Team (for application support and payments)',
    tel: '020 3627 4647',
  },
  {
    title: 'Marketing',
    email: 'marketing@ideal4finance.co.uk',
  },
];
